"use client";
import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import { Link, usePathname } from "@/i18n/navigation";
import { getRouteDetails } from "@/utils/routeHelper";
import { byPrefixAndName } from "@awesome.me/kit-12cf79935c/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";

export default function ProductNavigationTabs() {
  const t = useTranslationDetector();
  const pathname = usePathname();
  const routeDetails = getRouteDetails(pathname);
  const {
    isHome,
    isFlightHome,
    isBusTicketHome,
    isFerryTicketHome,
    isCarRentalHome,
    isHotelHome,
  } = routeDetails;
  return (
    <>
      <Link
        href="/flight"
        className={clsx(
          "group flex flex-col items-center justify-between gap-1 text-center transition-transform duration-150 [@media(hover:none)]:active:scale-90",
          (isFlightHome || isHome) && "text-primary",
        )}
      >
        <span
          className={clsx(
            "group-hover:bg-primary flex h-11 w-11 items-center justify-center rounded-lg p-2 transition-all duration-300 group-hover:-translate-y-1 group-hover:text-white md:h-14 md:w-14",
            (isFlightHome || isHome) && "bg-primary text-white",
          )}
        >
          <FontAwesomeIcon
            icon={byPrefixAndName.fak["new-flight"]}
            className="text-[28px] md:text-4xl"
          />
        </span>
        <span className="text-sm font-medium md:text-base">
          {t("header.flight")}
        </span>
      </Link>
      <Link
        href="/hotel"
        className={clsx(
          "group flex flex-col items-center justify-between gap-1 text-center transition-transform duration-150 [@media(hover:none)]:active:scale-90",
          isHotelHome && "text-primary",
        )}
      >
        <span
          className={clsx(
            "group-hover:bg-primary relative flex h-11 w-11 items-center justify-center overflow-hidden rounded-lg p-2 transition-all duration-300 group-hover:-translate-y-1 group-hover:text-white md:h-14 md:w-14",
            isHotelHome && "bg-primary text-white",
          )}
        >
          <FontAwesomeIcon
            icon={byPrefixAndName.fak["new-hotel"]}
            className="text-[28px] md:text-4xl"
          />
        </span>
        <span className="text-sm font-medium md:text-base">
          {t("header.hotel")}
        </span>
      </Link>
      <Link
        href="/bus-ticket"
        className={clsx(
          "group flex flex-col items-center justify-between gap-1 text-center transition-transform duration-150 [@media(hover:none)]:active:scale-90",
          isBusTicketHome && "text-primary",
        )}
      >
        <span
          className={clsx(
            "group-hover:bg-primary flex h-11 w-11 items-center justify-center rounded-lg p-2 transition-all duration-300 group-hover:-translate-y-1 group-hover:text-white md:h-14 md:w-14",
            isBusTicketHome && "bg-primary text-white",
          )}
        >
          <FontAwesomeIcon
            icon={byPrefixAndName.fak["new-bus"]}
            className="text-[28px] md:text-4xl"
          />
        </span>
        <span className="text-sm font-medium md:text-base">
          {t("header.bus")}
        </span>
      </Link>
      <Link
        href="/car-rental"
        className={clsx(
          "group flex flex-col items-center justify-between gap-1 text-center transition-transform duration-150 [@media(hover:none)]:active:scale-90",
          isCarRentalHome && "text-primary",
        )}
      >
        <span
          className={clsx(
            "group-hover:bg-primary flex h-11 w-11 items-center justify-center rounded-lg p-2 transition-all duration-300 group-hover:-translate-y-1 group-hover:text-white md:h-14 md:w-14",
            isCarRentalHome && "bg-primary text-white",
          )}
        >
          <FontAwesomeIcon
            icon={byPrefixAndName.fak["new-car"]}
            className="text-[28px] md:text-4xl"
          />
        </span>
        <span className="text-sm font-medium md:text-base">
          {t("header.car")}
        </span>
      </Link>
      <Link
        href="/ferry"
        className={clsx(
          "group flex flex-col items-center justify-between gap-1 text-center transition-transform duration-150 [@media(hover:none)]:active:scale-90",
          isFerryTicketHome && "text-primary",
        )}
      >
        <span
          className={clsx(
            "group-hover:bg-primary flex h-11 w-11 items-center justify-center rounded-lg p-2 transition-all duration-300 group-hover:-translate-y-1 group-hover:text-white md:h-14 md:w-14",
            isFerryTicketHome && "bg-primary text-white",
          )}
        >
          <FontAwesomeIcon
            icon={byPrefixAndName.fak["new-ferry"]}
            className="text-[28px] md:text-4xl"
          />
        </span>
        <span className="text-sm font-medium md:text-base">
          {t("header.ferry")}
        </span>
      </Link>
      <Link
        href="/credit-card-points"
        className={clsx(
          "group hidden items-center justify-between gap-1 text-center transition-transform duration-150 md:flex md:flex-col [@media(hover:none)]:active:scale-90",
        )}
      >
        <span
          className={clsx(
            "group-hover:bg-primary h-11 w-11 items-center justify-center rounded-lg p-2 transition-all duration-300 group-hover:-translate-y-1 group-hover:text-white md:flex md:h-14 md:w-14",
          )}
        >
          <FontAwesomeIcon
            icon={byPrefixAndName.fak["new-card"]}
            className="text-[28px] md:text-4xl"
          />
        </span>
        <span className="text-sm font-medium md:text-base">
          {t("header.pointconvert")}
        </span>
      </Link>
    </>
  );
}
